import { render, staticRenderFns } from "./Approvers.vue?vue&type=template&id=5b64c8ce&scoped=true"
import script from "./Approvers.vue?vue&type=script&lang=js"
export * from "./Approvers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64c8ce",
  null
  
)

export default component.exports